import { BaseIcon } from './base';
import type { IconSmallProps } from './base';

export function IconHireSmall(props: IconSmallProps) {
  return (
    <BaseIcon {...props} size={16} viewBox="0 0 16 16">
      <path
        d="M7.19535 6.53295L9.4176 4.20254C9.71473 3.89095 9.71473 3.37164 9.4176 3.05356L8.43337 2.02143L9.08953 1.33334L10.0738 2.36548C10.7361 3.06005 10.7361 4.19605 10.0738 4.89063L7.8515 7.22104L7.19535 6.53295Z"
        fill="currentColor"
      />
      <path
        d="M5.95719 5.23467L6.32241 4.85168C6.61954 4.54009 6.61954 4.02078 6.32241 3.70919L5.95719 3.3262L6.61335 2.63162L6.97856 3.01462C7.6409 3.70919 7.6409 4.84519 6.97856 5.53977L6.61335 5.92276L5.95719 5.23467Z"
        fill="currentColor"
      />
      <path
        d="M9.08991 8.51931L12.5502 4.89062C12.8535 4.57255 13.3425 4.57255 13.6458 4.89062L14.011 5.27362L14.6672 4.58553L14.302 4.20254C13.6396 3.50796 12.5564 3.50796 11.894 4.20254L8.43376 7.83123L9.08991 8.51931Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.3335 14.6667L9.99965 11.421L4.42855 5.57872L1.3335 14.6667ZM7.74026 10.8887L3.37623 12.5245L4.93614 7.94808L7.74026 10.8887Z"
        fill="currentColor"
      />
      <path
        d="M10.6556 8.09737L9.67139 9.12951L10.3275 9.81759L11.3118 8.78546C11.6151 8.46738 12.1041 8.46738 12.4074 8.78546L13.404 9.83058L14.0602 9.14249L13.0636 8.09737C12.395 7.40279 11.318 7.40279 10.6556 8.09737Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
